"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createStyles = _interopRequireDefault(require("@material-ui/core/styles/createStyles"));
var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var useStyles = (0, _makeStyles.default)(theme => (0, _createStyles.default)({
  textContent: {
    color: theme.palette.common.black,
    fontSize: theme.typography.pxToRem(18),
    textTransform: 'uppercase'
  },
  divider: {
    color: theme.palette.common.black,
    border: "1px solid ".concat(theme.palette.common.black)
  }
}), {
  name: 'SectionSeparator'
});
var _default = exports.default = useStyles;